import {
  FAQSvg,
  SAVSvg,
  FactureSvg,
  CatalogueSvg,
  ProspectsSvg,
  DashboardSvg,
  CalendrierSvg,
  CommandesSvg,
  MonEquipeSVG,
  TransporterSvg,
  DepotSvg,
  TruckFastSvg,
} from "../../Svgs";
import { IaAssistantSvg } from "../../Ia/IaIcons";

export const onglets = [
  {
    name: "Dashboard",
    icon: (color) => <DashboardSvg color={color} />,
    to: "/",
    roles: [0, 1, 2],
  },
  {
    name: "Products",
    icon: (color) => <CatalogueSvg color={color} />,
    to: "/produits",
    roles: [1],
  },
  {
    name: "Catalogue",
    icon: (color) => <CatalogueSvg color={color} />,
    to: "/catalogue",
    roles: [0, 1, 2, 7],
  },
  {
    name: "Orders",
    icon: (color) => <CommandesSvg color={color} />,
    to: "/commandes",
    roles: [0, 1, 2, 7],
  },
  {
    name: "Logistics",
    icon: (color) => <DepotSvg color={color} />,
    to: "/logistics",
    roles: [1],
  },
  // {
  //   name: "Depot",
  //   icon: (color) => <DepotSvg color={color} />,
  //   to: "/depots",
  //   roles: [1],
  // },
  // {
  //   name: "Transporters",
  //   icon: (color) => <TransporterSvg color={color} />,
  //   to: "/transporteurs",
  //   roles: [1],
  // },
  {
    name: "Delivery",
    icon: (color) => <TruckFastSvg color={color} />,
    to: "/livraison",
    roles: [2, 3],
  },
  {
    name: "Delivery",
    icon: (color) => <TruckFastSvg color={color} />,
    to: "/livraison",
    roles: [0, 4],
  },
  {
    name: "Partners",
    icon: (color) => <ProspectsSvg color={color} />,
    to: "/partenaires",
    roles: [1, 2],
  },
  {
    name: "Resellers",
    icon: (color) => <ProspectsSvg color={color} />,
    to: "/revendeur",
    roles: [0],
  },
  {
    name: "Customer space",
    icon: (color) => <ProspectsSvg color={color} />,
    to: "/clients-app",
    roles: [0, 1, 2, 7],
  },
  // {
  //   name: "Prospects",
  //   icon: (color) => <ProspectsSvg color={color} />,
  //   to: "/prospects",
  //   roles: [1, 2],
  // },
  // {
  //   name: "Account Managers",
  //   icon: (color) => <MonEquipeSVG color={color} />,
  //   to: "/apporteur-affaires",
  //   roles: [1],
  // },

  {
    name: "AS",
    icon: (color) => <SAVSvg color={color} />,
    to: "/sav",
    roles: [0, 1, 2],
  },
  {
    name: "Calendar",
    icon: (color) => <CalendrierSvg color={color} />,
    to: "/calendrier",
    roles: [0, 1, 2],
  },
  {
    name: "Guides",
    icon: (color) => <FAQSvg color={color} />,
    to: "/guide",
    roles: [0, 1, 2, 7],
  },
  {
    name: "Invoices",
    icon: (color) => <FactureSvg color={color} />,
    to: "/facture",
    roles: [0, 2],
  },
  {
    name: "My team",
    icon: (color) => <MonEquipeSVG color={color} />,
    to: "/equipe",
    roles: [0, 1],
  },
  {
    name: "AI Assistant",
    icon: (color) => <IaAssistantSvg color={color} size={20} />,
    to: "/assistant-ia",
    roles: [1],
  },
];
